/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformEphemerisTableResponse } from '../../models/platform-ephemeris-table-response';

export interface GetEphemerisTable$Params {

/**
 * Begin van het venster (ISO-8601, UTC). Verplicht.
 */
  fromUtc?: string | null;

/**
 * Einde van het venster (ISO-8601, UTC, exclusief). Verplicht, na fromUtc.
 */
  toUtc?: string | null;
}

export function getEphemerisTable(http: HttpClient, rootUrl: string, params?: GetEphemerisTable$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisTableResponse>> {
  const rb = new RequestBuilder(rootUrl, getEphemerisTable.PATH, 'get');
  if (params) {
    rb.query('fromUtc', params.fromUtc, {});
    rb.query('toUtc', params.toUtc, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformEphemerisTableResponse>;
    })
  );
}

getEphemerisTable.PATH = '/api/Ephemeris/table';
